module.exports = __webpack_public_path__ + "img/Passives_16@2x.a42f1fe5.png";